/**
 * i18next 初期化設定
 * マスター定義ファイルから各言語のリソースを自動生成
 * Redis 上書きは useDictionaryOverrides で別途マージ
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { extractResources, COMMON } from "@shift-management/shared/locales";

i18n.use(initReactI18next).init({
    lng: "ja",
    fallbackLng: "ja",
    defaultNS: "common",
    ns: ["common"],
    resources: {
        ja: {
            common: extractResources(COMMON, "ja"),
        },
        en: {
            common: extractResources(COMMON, "en"),
        },
    },
    interpolation: {
        escapeValue: false, // React が XSS 対策済み
    },
    react: {
        useSuspense: false, // 同期的に t() を使用
    },
});

export default i18n;
